import type { TPlaceholderValues } from "#/generate/types";

const PLACEHOLDER_PATTERN = /\{\{([a-zA-Z0-9]+)\}\}/g;

export function interpolatePlaceholders(
  templateContents: string,
  placeholders: TPlaceholderValues,
): string {
  return templateContents.replace(PLACEHOLDER_PATTERN, (_match, rawKey: string) => {
    let value = placeholders[rawKey];

    if (value === undefined) {
      throw new Error(`Unresolved placeholder: {{${rawKey}}}`);
    }

    return value;
  });
}
